import AxiosManager from "../../../util/axiosLib/axiosManager";
import apiManager from "../../../utilNew/apiManager";


var apiUrl=process.env.VUE_APP_apiUrl +"/";
// var apiUrl="http://127.0.0.1:8000/";
// var apiUrl= "https://kianseng.org/"
// var apiPathBase="api/test/";
var apiPathBase="api/tzapi/";
// var apiPathBase="api/admin/";





export default {
    //---------------axios------------------------
    getAxiosManager(){
        return new AxiosManager("sessionkey" + "tokenkey")
    },
    //---------------------------------------

    //---------------------------------------
    getApiManager() {
        return new apiManager(apiUrl,apiPathBase,"",this.getAxiosManager(),null)
    },

    // api_Test ( data)
    // {
    //     debugger // eslint-disable-line
    //     // return this.getApiManager().api_CallMethod_SendObj("testPost",data)
    //     return this.getApiManager().api_CallMethod_ByParamObj("testPost",data)
    // },
    // api_Upload (file, data)
    // {
    //     debugger // eslint-disable-line
    //     // return this.getApiManager().api_CallMethod_SendObj("testPost",data)
    //     return this.getApiManager().api_UpdateFile("upload",file,data)
    // },

    //---------------------------------------


    api_Admin_Question_Query ()
    {
        let data={
        }

        return this.getApiManager().api_CallMethod_ByParamObj("Admin_Question_Query",data)
    },

    api_Admin_Question_Save (questions)
    {
        let data={
            json:JSON.stringify(questions)
        }

        return this.getApiManager().api_CallMethod_ByParamObj("Admin_Question_Save",data)
    },

    api_Admin_Answer_Query ( questionSystemId)
    {
        let data={
            questionSystemId:questionSystemId,
        }

        return this.getApiManager().api_CallMethod_ByParamObj("Admin_Answer_Query",data)
    },
    api_Admin_Answer_Save (relQuestion, answers)
    {
        let data={
            relQuestion:relQuestion,
            json:JSON.stringify(answers)
        }

        return this.getApiManager().api_CallMethod_ByParamObj("Admin_Answer_Save",data)
    },

    //--------------------
    async api_Admin_GetUsers ()
    {
        let data={
        }

        let dataReturn=  await this.getApiManager().api_CallMethod_ByParamObj("Admin_GetUsers",data);
        return dataReturn.data.data;
    },

    async api_Admin_GetUser (userId)
    {
        let data={
            userId:userId,
        }

        let dataReturn=  await this.getApiManager().api_CallMethod_ByParamObj("Admin_GetUser",data);
        return dataReturn.data.data;
    },

    async api_Admin_UpdateUser (userId,area,alias)
    {
        let data={
            userId:userId,
            area:area,
            alias:alias,
        }

        let dataReturn=  await this.getApiManager().api_CallMethod_ByParamObj("Admin_UpdateUser",data);
        return dataReturn.data.data;
    },

    async api_Admin_GetUserProfile (userId)
    {
        let data={
            userId:userId,
        }

        let dataReturn=  await this.getApiManager().api_CallMethod_ByParamObj("Admin_GetUserProfile",data);
        return dataReturn.data.data;
    },


    async api_Admin_GetUserFiles (userId)
    {
        let data={
            userId:userId,
        }

        let dataReturn=  await this.getApiManager().api_CallMethod_ByParamObj("Admin_GetUserFiles",data);
        return dataReturn.data.data;
    },


    async api_Admin_UpdateUserFiles (userId,json)
    {
        let data={
            userId:userId,
            json:JSON.stringify(json)
        }

        let dataReturn=  await this.getApiManager().api_CallMethod_ByParamObj("Admin_UpdateUserFiles",data);
        return dataReturn.data.data;
    },

    async api_Admin_GetSuggest (userId)
    {
        let data={
            userId:userId,
        }

        let dataReturn=  await this.getApiManager().api_CallMethod_ByParamObj("Admin_GetSuggest",data);
        return dataReturn.data.data;
    },

    async api_Admin_UpdateSuggest (userId,json)
    {
        let data={
            userId:userId,
            json:json,
        }

        let dataReturn=  await this.getApiManager().api_CallMethod_ByParamObj("Admin_UpdateSuggest",data);
        return dataReturn.data.data;
    },

    async api_Admin_UpdateSuggest_caseManagerSuggest (userId,suggest)
    {
        let data={
            userId:userId,
            suggest:suggest,
        }

        let dataReturn=  await this.getApiManager().api_CallMethod_ByParamObj("Admin_UpdateSuggest_caseManagerSuggest",data);
        return dataReturn.data.data;
    },

    async api_Admin_GetQuestionAnswered (userId)
    {
        let data={
            userId:userId,
        }

        let dataReturn=  await this.getApiManager().api_CallMethod_ByParamObj("Admin_GetQuestionAnswered",data);
        return dataReturn.data.data;
    },

    async api_Admin_GetCase (userId)
    {
        let data={
            userId:userId,
        }

        let dataReturn=  await this.getApiManager().api_CallMethod_ByParamObj("Admin_GetCase",data);
        return dataReturn.data.data;
    },

    async api_Admin_UpdateCase (relUserId,tag1,tag2,tag3,content,memo)
    {
        let data={
            relUserId:relUserId,
            tag1:tag1,
            tag2:tag2,
            tag3:tag3,
            memo1:content,
            memo2:memo,
        }

        let dataReturn=  await this.getApiManager().api_CallMethod_ByParamObj("Admin_UpdateCase",data);
        return dataReturn;
    },

    async api_Admin_GetCaseLog (relUserId)
    {
        let data={
            relUserId:relUserId,
        }

        let dataReturn=  await this.getApiManager().api_CallMethod_ByParamObj("Admin_GetCaseLog",data);
        return dataReturn.data.data;
    },

    async api_Admin_QueryCaseLog ()
    {
        let data={
            // relUserId:relUserId,
        }

        let dataReturn=  await this.getApiManager().api_CallMethod_ByParamObj("Admin_QueryCaseLog",data);
        return dataReturn.data.data;
    },

    async api_Admin_UpdateCaseLog (id,relUserId,tag1,tag2,tag3,content,memo)
    {
        let data={
            id:id,
            relUserId:relUserId,
            tag1:tag1,
            tag2:tag2,
            tag3:tag3,
            memo1:content,
            memo2:memo,
        }

        let dataReturn=  await this.getApiManager().api_CallMethod_ByParamObj("Admin_UpdateCaseLog",data);
        return dataReturn;
    },


    async api_Admin_DelCaseLog (id)
    {
        let data={
            id:id,
        }

        let dataReturn=  await this.getApiManager().api_CallMethod_ByParamObj("Admin_DelCaseLog",data);
        return dataReturn;
    },
    async api_Admin_UpdateCase_IsFinish (id,isFinish)
    {
        if (isFinish){
            isFinish=1;
        }else{
            isFinish=0;
        }
        let data={
            id:id,
            isFinish:isFinish,
        }

        let dataReturn=  await this.getApiManager().api_CallMethod_ByParamObj("Admin_UpdateCase_IsFinish",data);
        return dataReturn;
    },
    async api_Admin_UpdateCaseLog_IsFinish (id,isFinish)
    {
        if (isFinish){
            isFinish=1;
        }else{
            isFinish=0;
        }

        let data={
            id:id,
            isFinish:isFinish,
        }

        let dataReturn=  await this.getApiManager().api_CallMethod_ByParamObj("Admin_UpdateCaseLog_IsFinish",data);
        return dataReturn;
    },

    async api_Admin_GetMedHistory (userId)
    {
        let data={
            userId:userId,
        }

        return await this.getApiManager().api_CallMethod_ByParamObj("Admin_GetMedHistory",data).data.data;
        let dataReturn=  await this.getApiManager().api_CallMethod_ByParamObj("Admin_GetMedHistory",data);
        return dataReturn.data.data;
    },

    async api_Admin_UpdateMedHistory (userId)
    {
        let data={
            userId:userId,
        }

        let dataReturn=  await this.getApiManager().api_CallMethod_ByParamObj("Admin_UpdateMedHistory",data);
        return dataReturn;
    },

    async api_Admin_GetMsgLog (userId)
    {
        let data={
            userId:userId,
        }

        let dataReturn=  await this.getApiManager().api_CallMethod_ByParamObj("Admin_GetMsgLog",data);
        return dataReturn.data.data;
    },

    async api_Admin_SendMsgLog (userId)
    {
        let data={
            userId:userId,
        }

        let dataReturn=  await this.getApiManager().api_CallMethod_ByParamObj("Admin_SendMsgLog",data);
        return dataReturn;
    },

    async api_Admin_GetHome ()
    {
        let data={
            // userId:userId,
        }

        let dataReturn=  await this.getApiManager().api_CallMethod_ByParamObj("Admin_GetHome",data);
        return dataReturn.data.data;
    },



}
